// 整合接口，每个接口整合了初屏的几个数据接口，详见每个接口的备注
import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API, BASE_XHH} = extractAPIValues()

/** 
 * 整合以下接口
  /chatroom/v2/friend/blacklist
  /chatroom/settings/get_cannot_view_state_list
  /chatroom/settings/get_account_settings
  /v2/task/once_tasks
  chatroom/settings/get_act_list actived:1 (actived:1是由于之前客户端有版本bug加的，一直带着就行)

  v3 修改了unread_count的计数方式，比起v2多了群聊的unread_count
 */
export function integrationAccount (args) {
	let url = BASE_API + '/chatroom/v3/index/account'
	return axiosGetHandler(url, args)
}

export function integrationPublic(args) {
  const url = BASE_API + "/chatroom/v2/index/public";
  return axiosGetHandler(url, args);
}

export function integrationMyRooms(args) {
  const url = BASE_API + "/chatroom/v2/index/my_rooms";
  return axiosGetHandler(url, args);
}



/** 
 * 整合以下接口
  /chatroom/friend/get_user_friends_list
  /chatroom/v1/msg/get_talk_list
  /chatroom/v2/friend/top
  /chatroom/v2/friend/recommend limit: 20 offset: 0
 */
export function integrationFriends (args) {
	let url = BASE_API + '/chatroom/v3/index/friends'
	return axiosGetHandler(url, args)
}

/** 
 * 整合以下接口
chatroom/settings/get_feedback_id
/chatroom/settings/help_center
/account/device/list
chatroom/v2/settings/faq_group_id
 */
export function integrationSettings (args) {
  let url = BASE_API + '/chatroom/v2/index/settings'
  return axiosGetHandler(url, args)
}


/** 
 * 整合以下接口
chatroom/v1/msg/meme/list
chatroom/v2/msg/meme/filter
 */
export function integrationMeme (args, formdata) {
  let url = BASE_API + '/chatroom/v2/index/meme'
	return axiosPostHandler(url, args, formdata)
}


export function integrationBlackMythBanner(){
  let url = BASE_API + '/chatroom/v2/common/tab'
  return axiosGetHandler(url)
}

export function getBannerList() {
  let url = BASE_API + '/chatroom/v2/common/chat/banner'
  return axiosGetHandler(url)
}